import { Box, Typography } from "@mui/material";

import EyeIcon from "../../../assets/SVG/eyeIcon";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React, { useState, useMemo, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Them
import {
  getPresenceList,
  putSubmitEntrance,
  putUpdatePresenceList,
} from "../../../api/area";
import SearchInput from "../../project/searchInput";
import ExitIcon from "../../../assets/SVG/exitIcon";

export default function TablePresence({ areaId, gridRef }) {
  const [rowData, setRowData] = useState([]);

  const arrNumber = ["اول", "دوم", "سوم"];

  // Column Definitions: Defines & controls grid columns.
  const [colDefs] = useState([
    {
      field: "user.name",
      headerName: "نام و نام خانوادگی",
      width: 225,
    },
    {
      field: "user.phone",
      headerName: "شماره تلفن",
      width: 150,
    },
    {
      field: "area",
      headerName: "ورود و خروج",
      width: 320,
      cellRenderer: (x, i) => {
        return (
          <>
            {x.data.dates.length > 0 ? (
              <>
                <Box
                  bgcolor={x.data.dates.map((b, c) =>
                    c + 1 === x.data.dates.length && !x.data.dates[c].exit
                      ? "#682C2C"
                      : c + 1 === x.data.dates.length && x.data.dates[c].exit
                      ? "#2C685C"
                      : "#2C685C"
                  )}
                  color="white"
                  borderRadius={"9px"}
                  height="29px"
                  display="flex"
                  alignItems={"center"}
                  gap="10px"
                  p="5px"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    for (let i = 0; i < x.data.dates.length; i++) {
                      if (x.data.dates.length === i + 1) {
                        if (!x.data.dates[i].exit) {
                          putUpdatePresenceList(
                            x.data.user.id,
                            areaId,
                            x.data.dates[i].id,
                            {
                              justSetExit: true,
                            }
                          )
                            .then((x) => {
                              getPresenceList(areaId)
                                .then((x) => setRowData(x))
                                .catch((z) => console.log(z));
                            })
                            .catch(() => {});
                        } else {
                          // putUpdatePresenceList(
                          //   x.data.user.id,
                          //   areaId,
                          //   x.data.dates[0].id,
                          //   {
                          //     justSetExit: false,
                          //   }
                          // )
                          //   .then((x) => {
                          //     getPresenceList(areaId)
                          //       .then((x) => setRowData(x))
                          //       .catch((z) => console.log(z));
                          //   })
                          //   .catch(() => {});
                          putSubmitEntrance(x.data.user.id, areaId)
                            .then((x) => {
                              getPresenceList(areaId)
                                .then((x) => setRowData(x))
                                .catch((z) => console.log(z));
                            })
                            .catch(() => {});
                        }
                      }
                    }
                  }}
                >
                  <ExitIcon />
                  {x.data.dates.map((b, c) => (
                    <>
                      {c + 1 === x.data.dates.length &&
                        !x.data.dates[c].exit && (
                          <Typography fontFamily="Shabnam" color="white">
                            {"ثبت خروج"}
                          </Typography>
                        )}
                      {c + 1 === x.data.dates.length &&
                        x.data.dates[c].exit && (
                          <Typography fontFamily="Shabnam" color="white">
                            {"ثبت ورود"}
                          </Typography>
                        )}
                    </>
                  ))}
                </Box>
              </>
            ) : (
              <>
                <Box
                  bgcolor={"#2C685C"}
                  color="white"
                  borderRadius={"9px"}
                  height="29px"
                  display="flex"
                  alignItems={"center"}
                  gap="10px"
                  p="5px"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    putSubmitEntrance(x.data.user.id, areaId)
                      .then((x) => {
                        getPresenceList(areaId)
                          .then((x) => setRowData(x))
                          .catch((z) => console.log(z));
                      })
                      .catch(() => {});
                  }}
                >
                  <ExitIcon />
                  <Typography fontFamily="Shabnam" color="white">
                    {"ثبت ورود"}
                  </Typography>
                </Box>
              </>
            )}
          </>
        );
      },
    },
    {
      field: "groupsWithAccess",
      headerName: "جزئیات ثبت ورود/خروج",
      width: 580,
      cellRenderer: (x) => {
        return (
          <>
            {x.data?.dates && (
              <Typography fontFamily="Shabnam">
                {x.data?.dates[0]?.entrance?.split("-", 2)[0]}
              </Typography>
            )}
            <Box display="flex" mr="10px">
              {x.data.dates?.map((z, i) => (
                <>
                  {i <= 1 && (
                    <>
                      <Typography
                        mr="10px"
                        fontFamily="Shabnam"
                      >{`ورود ${arrNumber[i]}:`}</Typography>
                      <Typography fontFamily="Shabnam">
                        {z.entrance?.split("-", 2)[1]}
                      </Typography>
                      {z.exit && (
                        <Typography
                          mr="10px"
                          fontFamily="Shabnam"
                        >{`خروج ${arrNumber[i]}:`}</Typography>
                      )}
                      {z.exit && (
                        <Typography fontFamily="Shabnam">
                          {z.exit?.split("-", 2)[1]}
                        </Typography>
                      )}
                    </>
                  )}
                </>
              ))}
              {x.data.dates.length > 2 && <Typography fontFamily="Shabnam" mr="10px" >و...</Typography>}
            </Box>
          </>
        );
      },
    },
  ]);

  useEffect(() => {
    if (areaId) {
      getPresenceList(areaId)
        .then((x) => setRowData(x))
        .catch((z) => console.log(z));
    }
  }, [areaId]);
  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));
  console.log(rowData);

  return (
    <>
      <SearchInput
        type="text"
        id="filter-text-box"
        // onInput={onFilterTextBoxChanged}
        // value={valueSearch}
        // onChange={(e)=>setValueSearch(e.target.value)}
        mb="5px"
        mr="20px"
      />
      {/* <Typography className="icon-flight-land" /> */}
      <div className="ag-theme-quartz" style={{ height: 440, marginTop: 10 }}>
        <AgGridReact
          pagination={true}
          ref={gridRef}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          // pagination={true}
          rowSelection="multiple"
          onSelectionChanged={(event) => console.log("Row Selected!")}
          onCellValueChanged={(event) =>
            console.log(`New Cell Value: ${event.value}`)
          }
        />
      </div>
    </>
  );
}
